module.exports = __webpack_public_path__ + "static/media/img_stp_card_diners.864276f5.png";